import React, { useContext, useEffect, useState } from "react"
import styled from "styled-components"
import ProductImageCard from "./ProductImageCard"
import { Link, useNavigate, useParams } from "react-router-dom"
import {  doc, getDoc } from "firebase/firestore"
import { db, useAuth } from "../firebase-config"
import { Oval } from "react-loader-spinner"
import Modal from "react-modal"
import OrderProcessing from "../components/OrderProcessing"
import { ProductDetailContext } from "../context/ProductDetailsProvider"
import PrimaryBtn from "../components/PrimaryBtn"

// const ReviewCard = ({ authorImage, authorName, content }) => {
//   return (
//     <ReviewCardBox>
//       <div style={{ display: "flex" }} className="review__author">
//         <img
//           style={{
//             width: "25px",
//             height: "25px",
//             borderRadius: "100px",
//             marginLeft: "0.5rem",
//           }}
//           src={authorImage}
//           alt=""
//         />
//         <label htmlFor="image">{authorName}</label>
//       </div>
//       <div className="review_description">
//         <p>{content}</p>
//       </div>
//     </ReviewCardBox>
//   )
// }

const ProductDetail = () => {
  const { productId } = useParams()
  const [showModal, setShowModal] = React.useState(false)

  const [checkout, setCheckout] = useState(false)
  const [shippingDetails, setShippingDetails] = useState({
    address: "",
    landmark: "",
    zipcode: "",
  })
  const [productDetails, setProductDetails] = useState([])
  const currentUser = useAuth()
  const productContext = useContext(ProductDetailContext)

  const closeModal = () => {
    setShowModal(false)
  }

  const navigate = useNavigate()
  let shopId = productDetails?.shopId?.split("/")

 

  const fetchProduct = async () => {
    let docId = productId.split(":")
    console.log(docId[1])
    try {
      const docRef = doc(db, "products", docId[1])
      const docSnap = await getDoc(docRef)

      setProductDetails(docSnap.data(), docId[1])
      console.log(docId[1])
      productContext.handleData(docSnap.data())
      productContext.handleDocId(docId[1])
    } catch (error) {
      console.error(error)
    }
  }



  const handleCheckout = e => {
    e.preventDefault()
    setCheckout(true)
  }

  useEffect(() => {
    fetchProduct()
  }, [productId])

  const customStyle = {
    content: {
      left: '2%',
      // right: '10%',
      width: "85%",
      // left: "25%",
      background: "#363537",
    },
    overlay: {
      background: "rgba(0,0,0,0.4)",
    },
  }
 
  return (
    <>
      <Modal
        ariaHideApp={false}
        style={customStyle}
        id="modal"
        isOpen={showModal}
        contentLabel="Contact Form"
        onRequestClose={closeModal}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span
            style={{
              textAlign: "right",
              fontSize: "2rem",
              userSelect: "none",
              cursor: "pointer",
            }}
            onClick={closeModal}
          >
            &times;
          </span>

          <OrderProcessing
            processToPayment={checkout}
            handleFormSubmit={handleCheckout}
            handlePaymentButton={() => setCheckout(false)}
            shippingDetails={shippingDetails}
            handleAddChange={e =>
              setShippingDetails({
                ...shippingDetails,
                address: e.target.value,
              })
            }
            handleLandMarkChange={e =>
              setShippingDetails({
                ...shippingDetails,
                landmark: e.target.value,
              })
            }
            handlePinCodeChange={e =>
              setShippingDetails({
                ...shippingDetails,
                zipcode: e.target.value,
              })
            }
            amount={productDetails?.productDetails?.discountedPrice? 
              productDetails?.productDetails?.discountedPrice : 
              productDetails?.productDetails?.originalPrice }
          />
        </div>
      </Modal>
      {productDetails?.productDetails ? (
        <ProductContainer>
          <ProductImageCard productImage={productDetails.productPhoto} />
          <ProductDetailBox>
            <ProductShortDetail>
              <ProductTitle>
                {productDetails?.productDetails?.productName}
              </ProductTitle>
            </ProductShortDetail>
            <ProductPriceDetail>
              <PriceAmount>{`$ ${productDetails?.productDetails?.originalPrice}`}</PriceAmount>
              <DiscountAmount>{`$ ${productDetails?.productDetails?.discountedPrice}`}</DiscountAmount>
            </ProductPriceDetail>
            <p className="prod__description">
              {productDetails?.productDetails?.description}
            </p>
            {productDetails?.shopId != `shop/${currentUser?.uid}` && (
              <ProductAction>
                <input min={1} max={10} defaultValue={1} type="number" />
                <BuyButton onClick={() => setShowModal(!showModal)}>
                  Buy Directly
                </BuyButton>
                <EnquiryButton
                  to={`/chat/${shopId[1]}`}
                >
                  Enquiry Seller
                </EnquiryButton>
                <EnquiryButtonMobo to={`/chat/${shopId[1]}`}>
                  Enquiry Seller
                </EnquiryButtonMobo>
              </ProductAction>
              
            )}
            {
              productDetails?.shopId === `shop/${currentUser?.uid}` &&
              <>
              <div>{`Wishlisted by ${productDetails?.productDetails?.wishlistedUser? productDetails?.productDetails?.wishlistedUser?.length: 0 } users`}</div>
              <PrimaryBtn label="Edit" handleBtn={() => navigate('/product')} />
              </>

            }
          </ProductDetailBox>
        </ProductContainer>
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Oval color={"#fafafa"} secondaryColor={"#dc1d13"} width={"30px"} />
        </div>
      )}
      <ProductReview></ProductReview>
      {productDetails?.productDetails && (
        <ReviewsContainer>
          <h3>Reviews</h3>
          <p>No Reviews Yet</p>
          {/* <ReviewCard
         authorImage={
           "https://upload.wikimedia.org/wikipedia/commons/8/89/Portrait_Placeholder.png"
         }
         authorName={"Aditya Singh"}
         content={"this product is awesome"}
       />
       <ReviewCard
         authorImage={
           "https://upload.wikimedia.org/wikipedia/commons/8/89/Portrait_Placeholder.png"
         }
         authorName={"Aditya Singh"}
         content={"this product is awesome"}
       /> */}
        </ReviewsContainer>
      )}
    </>
  )
}

export default ProductDetail

const ProductContainer = styled.div`
  display: flex;
  justify-content: space-between;
  background: ${({ theme }) => theme.background};
  padding: 1rem;

  @media (max-width: 990px) {
    flex-direction: column;
  }

 
`

const ProductDetailBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 45%;

  .prod__description {
    font-size: 1rem;
  }
`

const ProductTitle = styled.p`
  font-size: 1.5rem;
  color: ${({ theme }) => theme.accent};
`
const ProductShortDetail = styled.div`
  display: flex;
  flex-direction: row;
`
const ProductPriceDetail = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 40%;
  height: 10%;

  @media (max-width: 768px) {
    width: 70%;
  }
`
const PriceAmount = styled.del`
  font-size: 1.2rem;
  font-weight: 400;
  color: ${({ theme }) => theme.text};
  opacity: 0.5;
`
const DiscountAmount = styled.h6`
  font-size: 1rem;
  font-weight: 200;
  color: green;
`

const ProductAction = styled.div`
  display: flex;

  input {
    width: 2rem;
    height: 2rem;
    border-radius: 5px;
    border: none;
    background: ${({ theme }) => theme.body};
    :focus {
      outline: none;
    }
  }
`
const BuyButton = styled.button`
  background: ${({ theme }) => theme.accent};
  padding: 0.5rem 1.5rem;
  border: none;
  border-radius: 5px;
  color: ${({ theme }) => theme.background};
  font-size: 1rem;
  font-weight: 400;
  cursor: pointer;
  margin-left: 1rem;

  :focus {
    outline: 1px;
  }
`
const EnquiryButton = styled(Link)`
  background: ${({ theme }) => theme.accent};
  padding: 0.5rem 1.5rem;
  border: none;
  border-radius: 5px;
  color: ${({ theme }) => theme.background};
  font-size: 1rem;
  font-weight: 400;
  cursor: pointer;
  text-decoration: none;
  margin-left: 1rem;

  :focus {
    outline: 1px;
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    display: none;
  }
`
const EnquiryButtonMobo = styled(Link)`
  display: none;
  background: ${({ theme }) => theme.accent};
  padding: 0.5rem 1.5rem;
  border: none;
  border-radius: 5px;
  color: ${({ theme }) => theme.background};
  font-size: 1rem;
  font-weight: 400;
  cursor: pointer;
  text-decoration: none;
  margin-left: 1rem;

  :focus {
    outline: 1px;
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    display: block;
  }
`

const ProductReview = styled.div`
  display: flex;
  background: ${({ theme }) => theme.background};
`

const ReviewCardBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 15rem;
  padding: 1rem;
  border-radius: 10px;
  background: ${({ theme }) => theme.background};
  margin-bottom: 0.5rem;
`

const ReviewsContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 0 1rem;
  height: 40vh;
  margin-bottom: 2rem;
  h3 {
    font-size: 1rem;
    color: ${({ theme }) => theme.accent};
    font-weight: 600;
  }

  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }
  ::-webkit-scrollbar-thumb {
    background-color: darkgrey;
    outline: 1px solid slategrey;
  }
`
const FormContainer = styled.form`
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;

  .input_cont {
    display: flex;
    flex-direction: column;
    align-items: center;

    justify-content: space-evenly;
    height: 20rem;
    width: 100%;
  }
`
const FormInput = styled.input`
  width: 55%;
  height: 1rem;
  padding: 1rem 0.5rem;
  border-radius: 5px;
  border: none;
  background: ${({ theme }) => theme.background};

  :focus {
    outline: none;
  }
`

const SendButton = styled.button`
  height: 2.8rem;
  background: ${({ theme }) => theme.accent};
  border: none;
  color: ${({ theme }) => theme.text};
  border-radius: 5px;
  width: 5rem;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0rem 4rem;
  cursor: pointer;
`
